import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

// Všechny komponenty normální import - žádné lazy loading!
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Customers from "./pages/Customers";
import CustomerDetail from "./pages/CustomerDetail";
import Machines from "./pages/Machines";
import MachineDetail from "./pages/MachineDetail";
import Templates from "./pages/Templates";
import Suppliers from "./pages/Suppliers";
import Parts from "./pages/Parts";
import Orders from "./pages/Orders";
import Settings from "./pages/Settings";
import AdminPanel from "./pages/AdminPanel";
import ClientMap from "./pages/ClientMap";
import DeliveryProtocols from "./pages/DeliveryProtocols";
import DeliveryWizard from "./pages/DeliveryWizard";
import AiAssistant from "./pages/AiAssistant";
import Upgrades from "./pages/Upgrades";
import UpgradeDetail from "./pages/UpgradeDetail";
import Maps3D from "./pages/Maps3D";
import Shipments from "./pages/Shipments";
import ShipmentDetail from "./pages/ShipmentDetail";
import ShipmentsSettings from "./pages/ShipmentsSettings";
import ShipmentsGuard from "./components/shipments/ShipmentsGuard";

const App = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => { 
    checkAuth(); 
  }, []);

  const checkAuth = async () => {
    try {
      const res = await fetch("/api/auth/me", { credentials: "include" });
      if (res.ok) {
        const json = await res.json();
        setUser(json.user || json.data);
      }
    } catch (e) {
      console.error('Auth error:', e);
    } finally {
      setLoading(false);
    }
  };

  const handleLogin = (userData) => setUser(userData);
  const handleLogout = () => setUser(null);

  if (loading) {
    return (
      <div style={{ 
        display: "flex", 
        alignItems: "center", 
        justifyContent: "center", 
        height: "100vh", 
        backgroundColor: "#f5f5f5"
      }}>
        <div style={{
          width: "40px",
          height: "40px",
          border: "4px solid #E0E0E0",
          borderTop: "4px solid #E53935",
          borderRadius: "50%",
          animation: "spin 1s linear infinite"
        }} />
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  return (
    <BrowserRouter>
      {!user ? (
        <Login onLogin={handleLogin} />
      ) : (
        <Layout user={user} onLogout={handleLogout}>
          <Routes>
            <Route path="/" element={<Dashboard user={user} />} />
            <Route path="/customers" element={<Customers />} />
            <Route path="/customers/:id" element={<CustomerDetail />} />
            <Route path="/machines" element={<Machines />} />
            <Route path="/machines/:id" element={<MachineDetail />} />
            <Route path="/mapa-klientu" element={<ClientMap />} />
            <Route path="/mapy-testy" element={<Maps3D />} />
            <Route path="/odvozy" element={<DeliveryProtocols />} />
            <Route path="/odvozy/:id" element={<DeliveryWizard />} />
            <Route path="/upravy" element={<Upgrades />} />
            <Route path="/upravy/:id" element={<UpgradeDetail />} />
            <Route path="/ai" element={<AiAssistant />} />
            <Route path="/suppliers" element={<Suppliers />} />
            <Route path="/parts" element={<Parts />} />
            <Route path="/orders" element={<Orders />} />
            <Route path="/templates" element={<Templates />} />
            <Route path="/settings" element={<Settings />} />
            {(user.role === 'admin' || user.role === 'manager') && (
              <Route path="/admin" element={<AdminPanel />} />
            )}
            {user.role === 'admin' && (
              <Route path="/zasilky" element={<ShipmentsGuard />}>
                <Route index element={<Shipments />} />
                <Route path="nastaveni" element={<ShipmentsSettings />} />
                <Route path=":id" element={<ShipmentDetail />} />
              </Route>
            )}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Layout>
      )}
    </BrowserRouter>
  );
};

export default App;
